import { createFileRoute } from "@tanstack/react-router";

import { CatalogRoute } from "../screens/catalog-route";

export const Route = createFileRoute("/skus")({
  component: () => <CatalogRoute path="/skus" kind="SKU" />,
});
